export default "__VITE_PUBLIC_ASSET__a60ff4d8__"